import { render, staticRenderFns } from "./section-propsdetail.vue?vue&type=template&id=4a3cfef8&scoped=true&"
import script from "./section-propsdetail.vue?vue&type=script&lang=js&"
export * from "./section-propsdetail.vue?vue&type=script&lang=js&"
import style0 from "./section-propsdetail.vue?vue&type=style&index=0&id=4a3cfef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3cfef8",
  null
  
)

export default component.exports